import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { RestApi } from '../shared/apiUrls';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { PromiseResult } from '../models/PromiseResult';
import {
    medprofUpdateDataSubmit
} from '../models/medicalproffessional';
import { profileFetch } from '../models/Doctorprofile';
@Injectable({
    providedIn: 'root'
})
export class OthermedicalregistrationService {
    constructor(private readonly http: HttpClient) {}
    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }
    createOtherMedicalReferrals(
        OtherMedicalData: FormData
    ): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.OtherMedicalReferralApi + 'create',
                OtherMedicalData
            )
            .pipe(catchError(this.handleError));
    }

    OtherMedicalUploadProfilePhoto(
        form: FormData,
        user_guid: string
    ): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(
                RestApi.Urls.ReferralApi +
                    'Doctor/Update/ProfilePhoto/' +
                    user_guid,
                form
            )
            .pipe(catchError(this.handleError));
    }

    OtherMedicalUploadResume(
        form: FormData,
        user_guid: string
    ): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(
                RestApi.Urls.OtherMedicalReferralApi +
                    'Update/Profile/Resume/' +
                    user_guid,
                form
            )
            .pipe(catchError(this.handleError));
    }
    getOtherMedicalProfileData(data: profileFetch): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.OtherMedicalApi + 'Profile/fetch',
                data
            )
            .pipe(catchError(this.handleError));
    }

    updateOtherMedicalProfileData(
        data: medprofUpdateDataSubmit
    ): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(
                RestApi.Urls.OtherMedicalApi +
                    'Profile/Update/' +
                    data.guid.user_guid,
                data
            )
            .pipe(catchError(this.handleError));
    }

    updateOtherMedicalResume(
        form: FormData,
        user_guid: string
    ): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(
                RestApi.Urls.OtherMedicalApi +
                    'Profile/Update/Resume/' +
                    user_guid,
                form
            )
            .pipe(catchError(this.handleError));
    }

    updateOtherMedicalProfilePhoto(
        form: FormData,
        user_guid: string
    ): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(
                RestApi.Urls.OtherMedicalApi +
                    'Profile/Update/Resume/' +
                    user_guid,
                form
            )
            .pipe(catchError(this.handleError));
    }

    getAllOtherProfessionsList() {
        return this.http
            .get<PromiseResult>(RestApi.Urls.OtherMedicalApi + 'GetAll')
            .pipe(catchError(this.handleError));
    }

    getOtherProfessionsProfileData(user_guid) {
        return this.http
            .get<PromiseResult>(
                RestApi.Urls.OtherMedicalApi +
                    'Profile/Get/featured/' +
                    user_guid
            )
            .pipe(catchError(this.handleError));
    }
}
